import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import AdminWorkflowBootstrap from './components/AdminWorkflowBootstrap'
import AdminFlowParityV3 from './components/AdminFlowParityV3'
import './styles.css'
import './admin-readability.css'
import './admin-controls.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <AdminWorkflowBootstrap />
    <AdminFlowParityV3 />
  </React.StrictMode>,
)
